import Axios from 'axios';

export async function fetchUserImagesByActivityIds(activity_ids, page = '') {
    const rootImage = process.env.BUILD_ENV !== 'prod' ? 'image-staging' : 'image';
    return Axios.get(
        `https://api.tripshock.com/${rootImage}/photo/excerpt?activity_ids=${activity_ids}`
    ).then(({ data }) => {
        if (data && typeof data === 'object') {
            return data;
        }
        console.log(`Failed fetchUserImages ${page}: /${page}`, activity_ids);
    });
}
